import {IHttpService} from "angular";
import {Securities} from "../../../instruments/types/CodeAndExchange";
import {SecurityInformationRecords} from "../types/SecurityInformationRecord";

export class SecurityInformationService {

    public static readonly id = "securityInformationService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async list(codes: Securities): Promise<SecurityInformationRecords> {
        if (codes.length === 0) {
            return [];
        } else {
            const url = `/tradefloor/api/security-information`;
            const response = await this.$http.post<SecurityInformationRecords>(url, codes);
            return response.data;
        }
    }
}
